<ng-container >
    <video id="Video" #videoElement class="video-element" webkit-playsinline playsInline="true"  [controls]="showVideoControls"
    (loadedmetadata)="_onLoadedVideo()" (click)="_mouseClick()" [ngClass]="{'visible': showVideo}"></video>
    <!-- <img id="fullscreenButton" [src]="fullscreenButtonSrc" (click)="_onClickFullscreenButton()" *ngIf="showFullScreenButton" /> -->
     <ng-container *ngIf="showFullScreenButton"><div id="fullscreenButton" (click)="_onClickFullscreenButton()" >
        <svg height="48px" viewBox="0 -960 960 960" width="48px" fill="#ffffff"><path d="M120-120v-193h60v133h133v60H120Zm527 0v-60h133v-133h60v193H647ZM120-647v-193h193v60H180v133h-60Zm660 0v-133H647v-60h193v193h-60Z"/></svg>
     </div></ng-container>
</ng-container>
